import styled from 'styled-components';
import { device } from 'src/theme/device';
import { remConvert } from 'src/theme/utils';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const PageContentContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;

  @media ${device.lg} {
    width: 425px;
  }

  p {
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    color: #616161;
    margin: 0;
  }
`;

export const PageTitle = styled.h1`
  font-family: ${({ theme }): string => theme.fontFamilies.primary};
  font-style: normal;
  font-weight: 700;
  font-size: 34px;
  line-height: 1.4;
  text-align: center;
  color: #212121;
  margin-bottom: 48px;

  @media ${device.lg} {
    max-width: 483px;
  }
`;

export const PageBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
  width: 100%;

  @media ${device.lg} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }
`;

export const PageShieldImage = styled.img`
  width: 150px;
  height: 150px;
  margin-bottom: 16px;

  @media ${device.lg} {
    margin-bottom: 0;
  }
`;

export const FooterText = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  color: #616161;
  margin: 0;

  span {
    color: ${({ theme }) => theme.colors.darkBlue.main};
    font-weight: 700;
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      opacity: 0.8;
    }
  }
`;
